export const MONS_CUSTOMER_ID_HEADER = '_debug_amz-mons-customer';
export const MONS_CUSTOMER_ID_SESSION = 'monsCustomerId';

export const CSRF_TOKEN_ID = 'anti-csrftoken-a2z';
